import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'is24-corecss'
import { RealEstateCategory, SegmentationType, TransactionType } from '../../../@types/types'
import { trackSegmentationEvent } from './segmentationTracking'
import styles from './FooterNotes.module.css'

interface FooterNotesProps {
  selectedSegmentation?: SegmentationType | null
  selectedTransaction?: TransactionType | 'SHORT_TERM_ACCOMMODATION' | null
  selectedRealEstate?: RealEstateCategory | 'BUSINESS' | null
}

export const FooterNotes: React.FC<FooterNotesProps> = ({
  selectedSegmentation,
  selectedTransaction,
  selectedRealEstate,
}) => {
  const { t } = useTranslation()

  const handleRatingClick = () => {
    trackSegmentationEvent({
      eventName: 'view_rating_click',
      selectedSegmentation,
      transactionType: selectedTransaction,
      realEstateCategory: selectedRealEstate,
    })
  }

  return (
    <div className={`grid grid-flex ${styles.footerNotes} desk-margin-top-l`}>
      <div className='font-body-small-regular font-gray grid-item' style={{ color: '#6A6A69' }}>
        {t('segmentation.footerNote1')}
      </div>
      <div
        className='font-body-small-regular font-gray grid-item grid grid-flex gap-s grid-align-center'
        style={{ color: '#6A6A69' }}
      >
        <span className={'grid-item'}>{t('segmentation.footerNote2')}</span>
        <Link
          className={'grid-item'}
          href={'https://www.ekomi.de/bewertungen-immobilien-scout24.html'}
          variant='weak'
          target='_blank'
          rel='noopener noreferrer'
          onClick={handleRatingClick}
        >
          {t('segmentation.footerLinkLabel')}
        </Link>
      </div>
    </div>
  )
}
